import React from 'react';
import ReactDOM from 'react-dom/client';
import KubeWorldV6 from './KubeWorld';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <KubeWorldV6 />
  </React.StrictMode>
);
